module.exports = "pegasus_template/assets/themecapture1/ebook/102.png";